<template>
  <div class="box-father" v-loading="exportLoading">
    <div style="height: 100%">
      <div class="box-header">
        <div class="box-header-left">
          <div class="box-header-left-text">统计分析管理&nbsp;/&nbsp;</div>
          <div class="box-header-right">
            <div>打卡轨迹</div>
          </div>
        </div>
      </div>
      <div class="section">
        <div class="biaodan2">
          <div class="biaodan-left">
            <div style="height: 100%; width: 100%">
              <el-form
                :inline="true"
                label-position="left"
                class="demo-form-inline"
                :model="form"
              >
                <el-form-item label="打卡数据来源">
                  <el-select
                    filterable
                    placeholder="请选择打卡数据来源"
                    clearable
                    v-model="form.taskType"
                  >
                    <el-option
                      v-for="item in taskTypeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="事项类型">
                  <el-input
                    v-model="form.eventName"
                    clearable
                    placeholder="请输入事项类型"
                  ></el-input>
                </el-form-item>
                <el-form-item label="打卡人部门">
                  <el-select
                    filterable
                    placeholder="请选择打卡人部门"
                    clearable
                    v-model="form.deptId"
                    @change="getUserList2Fun"
                  >
                    <el-option
                      v-for="item in deptList"
                      :key="item.id"
                      :label="item.deptName"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="打卡人姓名">
                  <el-select
                    filterable
                    placeholder="请选择打卡人姓名"
                    clearable
                    v-model="form.userId"
                  >
                    <el-option
                      v-for="item in userList"
                      :key="item.id"
                      :label="item.userName"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="定位地址">
                  <el-input
                    v-model="form.address"
                    clearable
                    placeholder="请输入定位地址"
                  ></el-input>
                </el-form-item>
                <el-form-item label="时间">
                  <el-date-picker
                    v-model="form.dayStr"
                    value-format="yyyy-MM-dd"
                    type="date"
                    placeholder="选择时间"
                    :clearable="false"
                  >
                  </el-date-picker>
                </el-form-item>

                <el-form-item class="form-item">
                  <el-button @click="onSearch" class="search">查询</el-button>
                  <el-button class="reset" @click="onReset">重置</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
        <div class="aside">
          <div class="table-top-btns">
            <div class="left-btn"></div>
            <div class="right-btn">
              <el-button
                @click="userLocationLineExpFun"
                icon="el-icon-download"
                class="search"
                >导出</el-button
              >
            </div>
          </div>
          <common-table
            :select="false"
            :page="page"
            :dataList="dataList"
            @handleCurrentChange="handleCurrentChange"
            @handleSizeChange="handleSizeChange"
            :maxHeight="640"
          >
          </common-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  userLocationLine,
  userLocationLineExp,
  authUserDeptList
} from "@/api/task.js";
import { getUserList2 } from "@/api/systemManagement.js";
import commonTable from "@/components/table/index.vue";
import moment from "moment";
export default {
  components: {
    commonTable
  },
  data() {
    return {
      form: {
        taskType: "",
        eventName: "",
        address: "",
        deptId: "",
        userId: "",
        dayStr: moment(new Date()).format("YYYY-MM-DD")
      },
      page: {
        size: 10,
        page: 1,
        total: 0
      },
      dataList: {
        tableData: [],
        columns: [
          {
            prop: "taskType",
            label: "打卡数据来源",
            width: 120
          },

          {
            prop: "eventName",
            label: "事项类型",
            width: 180
          },
          {
            prop: "deptName",
            label: "打卡人部门",
            width: 140
          },
          {
            prop: "userName",
            label: "打卡人姓名",
            width: 100
          },

          {
            prop: "longitude",
            label: "经度",
            width: 180
          },
          {
            prop: "latitude",
            label: "纬度",
            width: 150
          },

          {
            prop: "address",
            label: "定位地址"
          },
          {
            prop: "submitTime",
            label: "时间",
            width: 240
          }
        ]
      },

      deptList: [],
      userList: [],
      taskTypeList: [
        {
          label: "自动打卡",
          value: "自动打卡"
        },
        {
          label: "任务清单",
          value: "任务清单"
        },
        {
          label: "日常巡查上报",
          value: "日常巡查上报"
        }
      ],
      exportLoading: false
    };
  },
  mounted() {
    this.authUserDeptListFun();
    this.getPointTypeListPageFun();
  },
  methods: {
    // 获取部门资源树形
    async authUserDeptListFun() {
      let params = {
        page: 999,
        size: 1
      };
      const res = await authUserDeptList(params);
      this.deptList = res.data.data;
    },
    // 获取部门资源树形
    async getUserList2Fun(deptId) {
      let params = {
        page: 1,
        size: 99999,
        deptId: deptId,
        zcUserTypeLike: "gov"
      };
      const res = await getUserList2(params);
      this.userList = res.data.data.dataList;
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.getPointTypeListPageFun();
    },
    handleCurrentChange(val) {
      this.page.page = val;
      this.getPointTypeListPageFun();
    },

    // 查询字典类型列表
    onSearch() {
      this.page.page = 1;
      this.page.size = 10;
      this.getPointTypeListPageFun();
    },
    onReset() {
      this.form.taskType = "";
      this.form.eventName = "";
      this.form.address = "";
      this.form.deptId = "";
      this.form.userId = "";
      this.form.dayStr = moment(new Date()).format("YYYY-MM-DD");
      this.page.page = 1;
      this.page.size = 10;
      this.getPointTypeListPageFun();
    },
    async userLocationLineExpFun() {
      this.exportLoading = true;
      let res = await userLocationLineExp({
        ...this.form
      });
      if (res.status == 200) {
        this.exportLoading = false;
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          "打卡轨迹" + new Date().getTime() + ".xlsx"
        );
        document.body.appendChild(link);
        link.click();
      }
    },
    // 分页查询
    async getPointTypeListPageFun() {
      let params = {
        ...this.form,
        page: this.page.page,
        size: this.page.size
      };
      const res = await userLocationLine(params);
      if (res.data.code == 200) {
        this.dataList.tableData = res.data.data.records
          ? res.data.data.records
          : [];
        this.page.total = res.data.data.total;
      }
    }
  }
};
</script>
<style scoped lang="less">
@import "~@/components/less.less";

.biaodan2 {
  width: 100%;
  margin-top: 1px;
  display: block;

  .form-item {
    padding: 0;
    margin: 0;
  }
}

.biaodan-left {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.demo-form-inline {
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  position: relative;
}

.section .el-form-item__label {
  text-align: left;
}

.el-button {
  height: 40px;
  font-size: 16px;
}

.table-header {
  height: 56px;
  padding: 8px 0;
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

/deep/.el-pagination .el-input--mini .el-input__inner,
/deep/.el-pagination.is-background .btn-next,
/deep/.el-pagination.is-background .btn-prev,
/deep/.el-pagination.is-background .el-pager li,
/deep/.el-pagination__jump .el-input__inner {
  height: 32px;
  line-height: 32px;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border-radius: 4px;
  border: 1px solid #0495ff;
  color: #0495ff;
  background: none;
}

/deep/.el-pagination__jump {
  margin-left: 0;
}

.tuihui {
  color: #eb3538;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/pages/dkgj/index.vue